import type { AnyApi } from '../buildCreateApi';
import type { EndpointDefinitions } from '../rtk-query-types';

import { createQueryFulfilledActionMatcher } from './actions/createQueryFulfilledActionMatcher';
import { createQueryRejectedActionMatcher } from './actions/createQueryRejectedActionMatcher';
import { createInvalidateTagsActionMatcher } from './actions/createInvalidateTagsActionMatcher';
import { createMutationFulfilledActionMatcher } from './actions/createMutationFulfilledActionMatcher';
import { createMutationRejectedActionMatcher } from './actions/createMutationRejectedActionMatcher';

import { addFulfilledTimeStamp } from './addFulfilledTimeStamp';
import { addInvalidatedByFromAction, addInvalidatedByFromMutation, removeInvalidatedBy } from './invalidatedBy';

// Патч редьюсера RTK Query API, реализующий необходимое поведение
export function patchApiReducer<Api extends AnyApi, Definitions extends EndpointDefinitions>(
    api: Api,
    definitions: Definitions
): Api['reducer'] {
    const isQueryRejectedAction = createQueryRejectedActionMatcher(api);
    const isQueryFulfilledAction = createQueryFulfilledActionMatcher(api);
    const isMutationRejectedAction = createMutationRejectedActionMatcher(api);
    const isMutationFulfilledAction = createMutationFulfilledActionMatcher(api);
    const isInvalidateTagsAction = createInvalidateTagsActionMatcher(api);

    return (state, action) => {
        let nextState = api.reducer(state, action);

        if (!nextState) {
            return nextState;
        }

        // Проставляем `fulfilledTimeStamp` в случае ошибки
        if (isQueryRejectedAction(action)) {
            nextState = addFulfilledTimeStamp(nextState, action);
        }

        // Проставляем `invalidatedBy` в случае ручной инвалидации
        if (isInvalidateTagsAction(action)) {
            nextState = addInvalidatedByFromAction(nextState, action, api);
        }

        // Проставляем `invalidatedBy` в случае инвалидации из мутации
        if (isMutationFulfilledAction(action) || isMutationRejectedAction(action)) {
            nextState = addInvalidatedByFromMutation(nextState, action, api, definitions);
        }

        // Удаляем `invalidatedBy` после завершения инвалидации
        if (isQueryFulfilledAction(action) || isQueryRejectedAction(action)) {
            nextState = removeInvalidatedBy(nextState, action);
        }

        return nextState;
    };
}
